import sample from './sample.js';

// Shuffle a collection.
export default function shuffle(obj) {
  return sample(obj, Infinity);
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/shuffle.js
// module id = 519
// module chunks = 8